export enum Route {
    ProductShow = "product",
    ProductDocumentsSearch = "product/documents",
}
